<div class="modal-dialog custom-modal-width"> <!-- Custom class for wider modal -->
  <div class="modal-content modal-box">
    <div class="modal-header d-flex justify-content-between align-items-start ">
      <h6 class="m-0">Add A Post</h6>
      <button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="row  ">
                <div class="col-1 mt-2" style="display:table-cell !important;">
                    <div class="user-avatar-container-top">
                        <img class="circular-image" [src]="'api/content/logo?userID=' + UserID">
                    </div>
                </div>

                <div class="col-11 ">
                    <!-- Post Content Input -->
                    <app-post-submit [Username]="Username"
                                     [UserID]="UserID"
                                     [pageType]="'postSubmitModal'"
                                     [mediaUrls]="mediaUrlsModal"
                                     [selectedReplyType]="selectedReplyType"
                                     (postContent)="updatePostContent($event)"
                                     (removeMedia)="removeMediaFromFooter($event)">
                    </app-post-submit>
                </div>
            </div>
            <div class="row" style="margin-top:5%">

                <!-- Footer for Media & Reply Options -->
                <app-post-footer #footerComponent
                                 [Username]="Username"
                                 [UserID]="UserID"
                                 [hasPostText]="hasPostText"
                                 [pageType]="'LeftModal'"
                                 (mediaUrlsChange)="updatePostMediaUrlsModal($event)"
                                 (replyTypeChange)="updateReplyTypeModal($event)"
                                 (onSave)="handleSave()">
                </app-post-footer>

            </div>
        </div>
    </div>
  </div>
</div>
